import { alphabetStandardLowercase } from "@nvon/baseline";
import { customAlphabet } from "nanoid";
import { useRef } from "react";
var generator = customAlphabet(alphabetStandardLowercase, 10);
/**
 * Generates a unique id that only changes when the component is mounted.
 */

export var useId = function useId(prefix) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  return useRef(prefix ? "".concat(prefix).concat(separator).concat(generator()) : generator()).current;
};